import React, { Component } from 'react';
import { Field, reduxForm } from 'redux-form'
import Link from '../../link.js';
import showResults from '../showResults.js';
import { renderTextField, required, email } from '../../fields/fields.js';

import {
    Container,
    Row,
    Col,
    NavItem,
    NavLink,
    Button,
    Form, FormGroup,
    Label, Input, FormText
} from 'reactstrap'


const loginForm = (props) => {
    const { handleSubmit, pristine, reset, submitting, translate } = props;

    return (
        <form onSubmit={handleSubmit} >
            <Row>
                <Col xl={12} lg={12} md={12}>
                    <Field translate={translate}
                        name="email"
                        type="email"
                        component={renderTextField}
                        label={('Email')}
                        validate={[required, email]}
                    ></Field>
                </Col>

                <Col xl={12} lg={12} md={12}>
                    <Field translate={translate}
                        name="password"
                        type="password"
                        component={renderTextField}
                        label={('Lozinka')}
                        validate={[required]}
                    ></Field>
                </Col>
            </Row>

            <Link to="/zaboravljena-lozinka" className="nav-link" lang={props.lang}>{props.translate("Zaboravili ste lozinku?")}</Link>
            <button className="btn"><span>{props.translate("Prijavi se")}</span></button>

        </form>


    )
}

export default reduxForm({
    form: 'loginForm',  // a unique identifier for this form

})(loginForm)
